/* christina-cart-runtime.js (dawniej christina-r6w4.js) — R6-W4 (2026-08-04), zmiany wydajnościowe R6-W6 (2026-08-04)
 * Naprawa szuflady koszyka, licznika po Back oraz higieny fokusu paska sticky.
 *
 * 1) GUARD theme.a11y.trapFocus  [PRZYCZYNA GLOWNEGO DEFEKTU]
 *    Stan zastany: po "Dodaj do koszyka" assets/cart.js -> cart-items.onCartUpdate wola
 *      theme.a11y.trapFocus(miniCart, miniCart.querySelector('.horizontal-product__title'))
 *    Gdy drugi argument jest null (pierwszy subskrybent pubsub widzi mini-koszyk jeszcze
 *    sprzed podmiany HTML — koszyk byl pusty, wiec nie ma zadnej pozycji), theme.a11y.trapFocus
 *    wykonuje elementToFocus.focus() -> TypeError. Domyslna wartosc parametru
 *    (elementToFocus = container) dziala tylko dla `undefined`, nie dla `null`.
 *    Wyjatek leci przez theme.pubsub.publish i przerywa dalsza czesc
 *    ProductForm.onSubmitHandler ZANIM ta zdazy wywolac cartDrawer.show().
 *    Objaw: produkt trafia do koszyka, licznik rosnie, szuflada sie nie otwiera,
 *    a zdarzenia 'cart:updated' oraz 'ajaxProduct:added' w ogole nie sa emitowane.
 *    Naprawa: null-safe wrapper — brak kontenera => no-op, brak elementu => pierwszy
 *    focusowalny element kontenera (zachowana intencja a11y), wyjatek => warn, nie throw.
 *
 * 2) SIATKA BEZPIECZENSTWA
 *    Po udanym POST /cart/add, jesli po 1100 ms szuflada nadal jest zamknieta,
 *    wysylamy natywne 'cart:refresh' {open:true} (obsluguje je <cart-drawer>).
 *    Dziala dla PDP, sticky, quick view i kart kolekcji — kazde z nich konczy sie
 *    tym samym zadaniem /cart/add. Nie dubluje otwarcia (sprawdza [open]).
 *
 * 3) LICZNIK KOSZYKA PO NAWIGACJI WSTECZ (bfcache)
 *    Strona przywrocona z bfcache / back-forward cache pokazuje licznik <cart-count>
 *    z chwili jej zapisania (np. 0, choc w koszyku jest 1 pozycja). Na 'pageshow'
 *    z persisted === true (albo gdy typ nawigacji to back_forward) dociagamy /cart.js
 *    i wyrownujemy licznik dokladnie tak, jak robi to natywny CartCount.onCartUpdate.
 *
 * 4) HIGIENA FOKUSU PASKA STICKY
 *    .christina-atf__sticky jest chowany wylacznie transformem (body.has-modal-open /
 *    body.has-cookie-banner / body.cc-keyboard-open). Element pozostawal w tab order
 *    i mial aktywny hitbox mimo braku widocznosci. Ustawiamy 'inert' + aria-hidden,
 *    gdy pasek jest poza ekranem, i zdejmujemy je, gdy wraca.
 *
 * ============================================================================
 * R6-W6 — DLACZEGO TEN PLIK BYL DRUGIM NAJDROZSZYM KODEM CHRISTINY
 * ============================================================================
 * Slad CDP (`traces\PRZED6-fn.json`, PDP mobile) zmierzyl:
 *     christina-r6w4.js :: syncSticky   561,1 ms scriptingu
 * i przypisal mu zadania po 204, 169, 161 i 146 ms. Przyczyna byla jedna:
 * punkt 4 byl podpiety pod `window.addEventListener('scroll')` i planowal
 * `requestAnimationFrame(syncSticky)`. To znaczy, ze przy KAZDEJ KLATCE
 * PRZEWIJANIA wykonywalismy `getComputedStyle()` oraz `getBoundingClientRect()`
 * na pasku — czyli WYMUSZALISMY przeliczenie ukladu w srodku zadania klatki,
 * ktore i tak zawiera styl, uklad i malowanie. Na kolekcji, gdzie paska
 * `.christina-atf__sticky` W OGOLE NIE MA, ta sama maszyneria (nasluch scroll,
 * rAF, MutationObserver na klasach <body>) chodzila jalowo.
 *
 * Zmiany R6-W6 — bez zmiany zachowania:
 *   a) CALA sekcja 4 startuje tylko wtedy, gdy na stronie jest przynajmniej
 *      jeden `.christina-atf__sticky`. Na kolekcji, stronie glownej i w koszyku
 *      nie zaklada sie ani jeden nasluch.
 *   b) Nie ma nasluchu `scroll` ani `resize` i nie ma `requestAnimationFrame`.
 *      Widocznosc paska w oknie ustala IntersectionObserver — uwzglednia
 *      transform i `display`, czyli dokladnie to, czym motyw chowa pasek,
 *      i NIE kosztuje ani jednego odczytu ukladu.
 *   c) `getComputedStyle` zostaje wylacznie na rozroznienie `visibility` /
 *      `opacity`, ktorych IntersectionObserver nie widzi — i jest wolany
 *      tylko w reakcji na zdarzenie (wpis IO, zmiana klasy <body> lub klasy
 *      paska, `transitionend`), a nie w petli. To kilka wywolan na strone
 *      zamiast kilkuset.
 *   d) Praca jest planowana przez `requestIdleCallback`, wiec nigdy nie
 *      wydluza zadania klatki.
 *   e) Awaryjny `setInterval(patchA11y, 50)` mial do 100 powtorzen (5 s
 *      timerow). W praktyce nie jest potrzebny ani razu: ten plik ma `defer`
 *      i stoi w `snippets/js-variables.liquid` ZA `theme.js`, wiec
 *      `theme.a11y` juz istnieje przy pierwszej probie. Zostaje siedem prob
 *      z rosnacym odstepem jako zabezpieczenie na wypadek zmiany kolejnosci.
 */
(function () {
  'use strict';

  /* R8C: guard calego pliku — sekcje 3 i 4 nie mialy zadnego zabezpieczenia przed podwojna inicjalizacja. */
  if (window.__ccCartRuntime) return;
  window.__ccCartRuntime = 1;

  /* ------------------------------------------------------------- narzedzia */

  function idle(fn, timeout) {
    var r = window.requestIdleCallback;
    if (r) { try { r(fn, { timeout: timeout || 400 }); return; } catch (e) { /* pomijamy */ } }
    setTimeout(fn, 32);
  }

  /* ------------------------------------------------------ 1. trapFocus guard */

  var a11yPatched = false;

  function patchA11y() {
    if (a11yPatched) return true;
    if (!window.theme || !theme.a11y || typeof theme.a11y.trapFocus !== 'function') return false;
    var orig = theme.a11y.trapFocus;
    if (orig.__r6w4) { a11yPatched = true; return true; }

    var safe = function (container, elementToFocus) {
      if (!container || typeof container.querySelectorAll !== 'function') return;
      var target = elementToFocus;
      if (target === null || target === undefined) {
        var list = [];
        try { list = theme.a11y.getFocusableElements(container) || []; } catch (e) {}
        target = list.length ? list[0] : container;
      }
      try {
        return orig(container, target);
      } catch (e) {
        if (window.console && console.warn) console.warn('[r6w4] trapFocus:', e && e.message);
      }
    };
    safe.__r6w4 = true;
    theme.a11y.trapFocus = safe;
    a11yPatched = true;
    return true;
  }

  if (!patchA11y()) {
    /* Siedem prob z rosnacym odstepem zamiast stu co 50 ms. */
    [30, 80, 200, 500, 1200, 3000, 6000].forEach(function (ms) {
      setTimeout(patchA11y, ms);
    });
    document.addEventListener('DOMContentLoaded', patchA11y, { once: true });
    window.addEventListener('load', patchA11y, { once: true });
  }

  /* ------------------------------------------------------------ helpers */

  function cartJsUrl() {
    var base = '/cart';
    try {
      if (window.theme && theme.routes && theme.routes.cart_url) base = theme.routes.cart_url;
    } catch (e) {}
    return base.replace(/\/$/, '') + '.js';
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  function drawerOpen() {
    var d = drawer();
    return !!(d && d.hasAttribute('open'));
  }

  /* -------------------------------------------------- 2. siatka bezpieczenstwa */

  function ensureDrawerOpen() {
    var d = drawer();
    if (!d || drawerOpen()) return;
    if (document.body.classList.contains('template-cart')) return;
    if (window.theme && theme.settings && theme.settings.cartType === 'page') return;
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
  }

  /* T-MOD4 (2026-10-31): siatka dotyczy tylko szuflady; przy cart_type=page nie owijamy fetch. */
  if (typeof window.fetch === 'function' && !window.fetch.__r6w4 && !(window.theme && theme.settings && theme.settings.cartType === 'page')) {
    var origFetch = window.fetch;
    var wrapped = function (input, init) {
      var promise = origFetch.apply(this, arguments);
      /* Tania sciezka: interesuje nas wylacznie /cart/add. Najpierw jedno
         `indexOf`, dopiero potem wyrazenie regularne — ta funkcja lezy na
         drodze KAZDEGO zadania sieciowego na stronie, takze cudzego. */
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      if (url && url.indexOf('/cart/add') > -1 && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        try {
          promise.then(function (response) {
            if (!response || !response.ok) return;
            setTimeout(ensureDrawerOpen, 1100);
          }).catch(function () {});
        } catch (e) {}
      }
      return promise;
    };
    wrapped.__r6w4 = true;
    window.fetch = wrapped;
  }

  /* ------------------------------------------ 3. licznik koszyka po Back */

  var syncing = false;

  function syncCartCount() {
    if (syncing) return;
    var els = document.querySelectorAll('cart-count');
    if (!els.length) return;
    syncing = true;
    fetch(cartJsUrl(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        syncing = false;
        if (!cart || typeof cart.item_count !== 'number') return;
        window.cb_current_cart_count = cart.item_count;
        var nodes = document.querySelectorAll('cart-count');
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          /* T-UPG603 (2026-10-11): Concept 6.0.3 renderuje licznik jako
             <span aria-hidden="true">N</span><span class="sr-only">, N elementow</span>.
             Zapis innerText na hoście kasowal oba spany (etykieta czytnika ekranu znikala).
             Piszemy tylko do spanu liczby; stary markup (bez spanu) bez zmian. */
          var num = el.querySelector('[aria-hidden="true"]') || el;
          if (parseInt(num.textContent, 10) === cart.item_count) continue;
          num.textContent = cart.item_count;
          var sr = num !== el && el.querySelector('.sr-only');
          var cs = window.theme && window.theme.cartStrings;
          if (sr && cs && cs.itemCountOne) {
            sr.textContent = ', ' + (cart.item_count === 1 ? cs.itemCountOne : cs.itemCountOther).replace('[count]', cart.item_count);
          }
          el.hidden = cart.item_count === 0;
        }
      })
      .catch(function () { syncing = false; });
  }

  function isBackForward() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') return true;
    } catch (e) {}
    return false;
  }

  window.addEventListener('pageshow', function (event) {
    if (event && event.persisted) { syncCartCount(); return; }
    if (isBackForward()) syncCartCount();
  });

  /* ------------------------------------------------ 4. inert dla paska sticky
   * Uwaga przy modyfikacjach: NIE wracac do nasluchu `scroll` + rAF.
   * Pasek chowa sie transformem, a transform widzi IntersectionObserver.
   */

  var BAR = '.christina-atf__sticky';
  var bars = [];
  var widoczneWOknie = null;   /* WeakMap-owy odpowiednik na malej liscie: indeks -> bool */
  var poprzedniStan = null;    /* R7-A3: ostatnio ustawiony stan paska (bool) */
  var ukryteStylem = null;     /* R7-A3: zapamietany werdykt getComputedStyle */
  var stylNieaktualny = null;  /* R7-A3: czy werdykt trzeba przeliczyc */
  var oczekuje = false;

  /* R8C: uchwyty do obserwatorow zalozonych przez initSticky. Trzymane w
     zasiegu modulu, zeby ponowne wywolanie initSticky (shopify:section:load)
     moglo je rozlaczyc zamiast mnozyc obserwatory na odlaczonych wezlach. */
  var ioSticky = null;
  var moBody = null;
  var moBar = null;

  /* R7-A3: klasy <body>, ktorymi motyw chowa pasek. Reagujemy WYLACZNIE na
     zmiane ktorejs z nich — kazda inna zmiana klasy <body> (a jest ich na
     stronie mnostwo: 'loaded', 'scrolled-down', 'has-modal-open' na innych
     elementach, klasy sekcji) nie ma prawa uruchamiac odczytu stylu. */
  var KLASY_PASKA = ['has-modal-open', 'has-cookie-banner', 'cc-keyboard-open'];
  var podpisKlasBody = null;

  function podpisKlas() {
    var cl = document.body && document.body.classList;
    if (!cl) return '';
    var s = '';
    for (var i = 0; i < KLASY_PASKA.length; i++) s += cl.contains(KLASY_PASKA[i]) ? '1' : '0';
    return s;   /* classList.contains nie wymusza przeliczenia ukladu */
  }

  function ustawStan(s, poza) {
    if (poza) {
      if (!s.hasAttribute('inert')) {
        s.setAttribute('inert', '');
        s.setAttribute('aria-hidden', 'true');
      }
    } else if (s.hasAttribute('inert')) {
      s.removeAttribute('inert');
      s.removeAttribute('aria-hidden');
    }
  }

  /* R7-A3 — DLACZEGO TA FUNKCJA BYLA DRUGIM NAJDROZSZYM KODEM CHRISTINY.
     Slad CDP (r7, PDP mobile) przypisal jej 207,0 ms czasu wlasnego. Kod
     rundy 6 wolal `getComputedStyle()` ZAWSZE i JAKO PIERWSZY — nawet
     wtedy, gdy IntersectionObserver juz wiedzial, ze paska nie ma w oknie.
     Kazde takie wywolanie po zmianie klasy <body> wymusza przeliczenie
     stylu calego dokumentu; przy dlawieniu 4x to kilkadziesiat ms za sztuke.
     Do tego `ustawStan` pisal atrybuty przy KAZDYM przebiegu, uniewazniajac
     styl i uzasadniajac kolejne przeliczenie.

     Trzy zmiany, bez zmiany zachowania:
       a) ODWROCONA KOLEJNOSC — najpierw pytamy IntersectionObserver. Gdy
          mowi, ze paska nie ma w oknie (transform, display:none, przewiniecie),
          konczymy BEZ zadnego odczytu stylu;
       b) `getComputedStyle` zostaje wylacznie dla `visibility` i `opacity`,
          ktorych IntersectionObserver nie rozroznia — czyli tylko wtedy, gdy
          pasek JEST w oknie;
       c) atrybuty pisane sa TYLKO przy faktycznej zmianie stanu. */
  function przelicz() {
    oczekuje = false;
    for (var i = 0; i < bars.length; i++) {
      var s = bars[i];
      var poza;
      if (widoczneWOknie && widoczneWOknie[i] === false) {
        poza = true;                       /* zero odczytow ukladu */
      } else {
        /* Styl czytamy TYLKO wtedy, gdy zaszlo cos, co moglo zmienic
           visibility albo opacity. Samo wjechanie paska w okno
           (wpis IntersectionObservera) tego nie zmienia, wiec korzystamy
           z zapamietanego werdyktu. */
        if (stylNieaktualny[i] !== false) {
          var cs = window.getComputedStyle(s);
          ukryteStylem[i] = cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05;
          stylNieaktualny[i] = false;
        }
        poza = ukryteStylem[i];
      }
      if (poprzedniStan[i] === poza) continue;   /* nic sie nie zmienilo */
      poprzedniStan[i] = poza;
      ustawStan(s, poza);
    }
  }

  /* Argument "uniewaznij" prawdziwy => trzeba ponownie odczytac styl. Wszystkie
     nasluchy zdarzen podpiete bezposrednio (transitionend, pageshow,
     drawer:*) przekazuja obiekt zdarzenia, ktory jest prawdziwy — i o to
     chodzi. Jedynym wolaniem z wartoscia falszywa jest IntersectionObserver. */
  function zaplanuj(uniewaznij) {
    if (uniewaznij && stylNieaktualny) {
      for (var i = 0; i < stylNieaktualny.length; i++) stylNieaktualny[i] = true;
    }
    if (oczekuje) return;
    oczekuje = true;
    idle(przelicz, 300);
  }

  function initSticky() {
    /* R8C: initSticky moze zostac wywolany ponownie (shopify:section:load).
       Stare obserwatory wskazuja wtedy na wezly usuniete z dokumentu — trzeba
       je rozlaczyc i wyczyscic stan, zanim zalozymy nowe. Nasluchy zdarzen
       (transitionend na paskach, document/window) uzywaja stalej referencji
       `zaplanuj`, wiec ponowne addEventListener ich nie dubluje, a stare paski
       znikaja razem z wezlami. */
    if (ioSticky) { try { ioSticky.disconnect(); } catch (e) {} ioSticky = null; }
    if (moBody) { try { moBody.disconnect(); } catch (e) {} moBody = null; }
    if (moBar) { try { moBar.disconnect(); } catch (e) {} moBar = null; }
    bars = [];
    widoczneWOknie = null;
    poprzedniStan = null;
    ukryteStylem = null;
    stylNieaktualny = null;
    oczekuje = false;

    bars = Array.prototype.slice.call(document.querySelectorAll(BAR));
    /* Brak paska = brak tematu. Na kolekcji i stronie glownej konczymy tutaj
       i nie zakladamy ANI JEDNEGO nasluchu. */
    if (!bars.length) return;
    widoczneWOknie = new Array(bars.length);
    poprzedniStan = new Array(bars.length);
    ukryteStylem = new Array(bars.length);
    stylNieaktualny = new Array(bars.length);
    for (var t0 = 0; t0 < bars.length; t0++) stylNieaktualny[t0] = true;
    podpisKlasBody = podpisKlas();

    /* a) Widocznosc w oknie — bez odczytu ukladu. Uwzglednia transform,
          czyli mechanizm, ktorym motyw chowa pasek. */
    if ('IntersectionObserver' in window) {
      ioSticky = new IntersectionObserver(function (wpisy) {
        for (var i = 0; i < wpisy.length; i++) {
          var idx = bars.indexOf(wpisy[i].target);
          if (idx > -1) widoczneWOknie[idx] = wpisy[i].isIntersecting;
        }
        zaplanuj(false);   /* wejscie/wyjscie z okna nie zmienia stylu */
      }, { threshold: 0 });
      for (var i = 0; i < bars.length; i++) ioSticky.observe(bars[i]);
    }

    /* b) Zmiana klasy <body> — has-modal-open / has-cookie-banner /
          cc-keyboard-open. R7-A3: filtrujemy po PODPISIE tych trzech klas,
          zeby kazda inna zmiana klasy <body> nie planowala odczytu stylu. */
    if (window.MutationObserver && document.body) {
      moBody = new MutationObserver(function () {
        var p = podpisKlas();
        if (p === podpisKlasBody) return;
        podpisKlasBody = p;
        zaplanuj(true);
      });
      moBody.observe(document.body, {
        attributes: true, attributeFilter: ['class']
      });
      /* c) Zmiana klasy albo stylu samego paska. */
      moBar = new MutationObserver(function () { zaplanuj(true); });
      for (var j = 0; j < bars.length; j++) {
        moBar.observe(bars[j], { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      }
    }

    /* d) Koniec animacji chowania/pokazywania — na samym pasku, nie na dokumencie. */
    for (var k = 0; k < bars.length; k++) {
      bars[k].addEventListener('transitionend', zaplanuj);
    }

    /* e) Szuflady i modale motywu. Nasluch na dokumencie, ale bez `scroll`. */
    ['modal:afterShow', 'modal:afterHide', 'drawer:afterShow', 'drawer:afterHide']
      .forEach(function (n) { document.addEventListener(n, zaplanuj, true); });

    window.addEventListener('pageshow', zaplanuj);

    /* f) Dwa kontrolne przebiegi na wypadek, gdyby IO nie zdazylo przed
          pierwszym renderem paska. */
    zaplanuj(true);
    setTimeout(function () { zaplanuj(true); }, 600);
    setTimeout(function () { zaplanuj(true); }, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky, { once: true });
  } else {
    initSticky();
  }

  /* R8C: po ponownym renderze sekcji (Theme Editor / Section Rendering API) stare
     wezly sa odlaczone — obserwatory trzeba zalozyc od nowa. initSticky jest
     idempotentny: sam rozlacza poprzednie obserwatory przed ponownym podpieciem. */
  document.addEventListener('shopify:section:load', initSticky);
})();
